import React from 'react'
import { connect } from 'react-redux'
import FormDropdown from './FormDropdown'
import Pagination from './Pagination'
import Bar from './Bar'
import RatingFilter from './RatingFilter'
import {
    ajaxCheckedFeedbackStatus,
    ajaxFeedbackFilterV2,
    ajaxFeedbackStatusFilter,
    checkPropertyValueByObjectIds,
    deleteDepartmentFilter,
    deleteEmployeeFilter,
    deleteNotWebToTextFilter,
    deleteOriginFilter,
    deleteQrCodeFilter,
    deleteRatingsFilter,
    deleteTagFilter,
    deleteWebToTextFilter,
    getDepartmentFilter,
    getEmployeeFilter,
    getNotWebToTextFilter,
    getOriginFilter,
    getQrCodeFilter,
    getRatingsFilter,
    getTagFilter,
    getWebToTextFilter,
    setCurrentPage,
    setDepartmentFilter,
    setEmployeeFilter,
    setNotWebToTextFilter,
    setOriginFilter,
    setPaginateCount,
    setQrCodeFilter,
    setRatingsFilter,
    setSorting,
    setTagFilter,
    setWebToTextFilter,
    splitArrayInByNumbers,
    updateCheckedFeedbacks,
    updateModalContent
} from '../redux/FeedbackRedux'
import { debounce } from 'lodash/function'

class FilterBar extends React.Component {
    constructor(props) {
        super(props);
        this.handleRatingsFilterChange = debounce(this.handleRatingsFilterChange.bind(this), 1000);
        this.handleDepartmentFilterChange = debounce(this.handleDepartmentFilterChange.bind(this), 1000);

        // states
        this.state = {
            showTagsList: false,
            showDeptList: false,
            showEmployeeList: false,
        };

        // Bind events for states
        this.handleTagsListToggle = this.handleTagsListToggle.bind(this);
        this.handleDeptListToggle = this.handleDeptListToggle.bind(this);
    }

    // Event handler to update state on button click
    handleTagsListToggle = () => {
        this.setState((prevState) => ({
            showTagsList: !prevState.showTagsList,
        }));
    }

    handleDeptListToggle = () => {
        this.setState((prevState) => ({
            showDeptList: !prevState.showDeptList,
        }));
    }

    handleRatingsFilterChange = e => {
        this.ratingsFilterChange();
    }

    handleDepartmentFilterChange = e => {
        this.departmentFilterChange();
    };

    handleOriginFilterChange = e => {
        this.originFilterChange();
    };

    handleTagFilterChange = e => {
        this.tagFilterChange();
    };

    handleEmployeeFilterChange = e => {
        this.employeeFilterChange();
    }

    toggleRatingsFilter(e) {
        const target = e.target;
        const ratingFilter = document.getElementById('rating-filter');

        if (target.checked) {
            ratingFilter.style.display = 'block';
        } else {
            ratingFilter.style.display = 'none';
        }

        this.handleRatingsFilterChange();
    }

    toggleDepartmentFilter(e) {
        const target = e.target;
        const departmentFilter = document.getElementById('department-filter');

        if (target.checked) {
            departmentFilter.style.display = 'block';
        } else {
            departmentFilter.style.display = 'none';
        }

        this.handleDepartmentFilterChange()
    }

    toggleEmployeeFilter(e) {
        const target = e.target;
        const employeeFilter = document.getElementById('employee-filter');

        employeeFilter.style.display = target.checked ? 'block' : 'none';

        if (!target.checked) {
            this.employeeFilterChange();
        }
    }

    toggleOriginFilter(e) {
        const target = e.target;
        const originFilter = document.getElementById('origin-filter');

        if (target.checked) {
            originFilter.style.display = 'block';
        } else {
            originFilter.style.display = 'none';
            const activeWebToTextFilter = document.getElementById('filter-web-to-text-checkbox');
            activeWebToTextFilter.checked = false;
            this.webToTextFilterChange();
            const activeQrCodeFilter = document.getElementById('filter-qr-codes-checkbox');
            activeQrCodeFilter.checked = false;
            this.qrCodeFilterChange();
        }

        this.handleOriginFilterChange()
    }

    toggleTagFilter(e) {
        const target = e.target;
        const tagFilter = document.getElementById('tag-filter');

        if (target.checked) {
            tagFilter.style.display = 'block';
        } else {
            tagFilter.style.display = 'none';
        }

        this.handleTagFilterChange()
    }

    ratingsFilterChange() {
        const activateRatingFilter = document.getElementById('activate-rating-filter');
        const starFilterInputs = document.querySelectorAll('.star-filter-input');
        const ratingFilter = document.getElementById('rating-filter');

        if (activateRatingFilter.checked && starFilterInputs.length > 0 && ratingFilter.style.display !== 'none') {
            const filterByRating = [];
            const existingFilterByRating = getRatingsFilter();

            starFilterInputs.forEach((input) => {
                if (this.props.state.status !== window.feedbackStatus.RatingsOnly.value && !existingFilterByRating) {
                    input.checked = true;
                }

                if (input.checked) {
                    filterByRating.push(parseInt(input.getAttribute('data-filter')));
                }
            });

            setRatingsFilter(filterByRating.length ? filterByRating : ['']);
        } else {
            deleteRatingsFilter();
        }

        this.props.dispatch(ajaxFeedbackFilterV2(true, true))
    }

    departmentFilterChange() {
        const activeDepartmentFilter = document.getElementById('activate-department-filter');
        const departmentFilterInputs = document.querySelectorAll('.department-filter-input');
        const departmentFilter = document.getElementById('department-filter');

        if (activeDepartmentFilter.checked && departmentFilterInputs.length > 0 && departmentFilter.style.display !== 'none') {
            const filterByDepartment = [];

            departmentFilterInputs.forEach((input) => {
                if (input.checked) {
                    filterByDepartment.push(parseInt(input.getAttribute('data-filter')));
                }
            });

            setDepartmentFilter(filterByDepartment.length ? filterByDepartment : [])
        } else {
            deleteDepartmentFilter();
        }

        this.props.dispatch(ajaxFeedbackFilterV2(true, true))
    }

    originFilterChange() {
        const activeOriginFilter = document.getElementById('activate-origin-filter');
        const originFilter = document.getElementById('origin-filter');

        if (activeOriginFilter.checked && originFilter.style.display !== 'none') {
            setOriginFilter(true)
        } else {
            deleteOriginFilter();
        }
    }

    tagFilterChange() {
        const activeTagFilter = document.getElementById('activate-tag-filter');
        const tagFilterInputs = document.querySelectorAll('.tag-filter-input');
        const tagFilter = document.getElementById('tag-filter');

        if (activeTagFilter.checked && tagFilterInputs.length > 0 && tagFilter.style.display !== 'none') {
            const filterByTag = [];

            tagFilterInputs.forEach((input) => {
                if (input.checked) {
                    filterByTag.push(parseInt(input.getAttribute('data-filter')));
                }
            });

            setTagFilter(filterByTag.length ? filterByTag : [])
        } else {
            deleteTagFilter();
        }

        this.props.dispatch(ajaxFeedbackFilterV2(true, true))
    }

    qrCodeFilterChange() {
        const activeQrCodeFilter = document.getElementById('filter-qr-codes-checkbox');
        const activeWebToTextFilter = document.getElementById('filter-web-to-text-checkbox');
        const activeNotWebToTextFilter = document.getElementById('filter-not-web-to-text-checkbox');

        if (activeQrCodeFilter.checked) {
            setQrCodeFilter()
            deleteWebToTextFilter()
            deleteNotWebToTextFilter()
            activeWebToTextFilter.checked = false;
            activeNotWebToTextFilter.checked = false;
        } else {
            deleteQrCodeFilter()
        }

        this.props.dispatch(ajaxFeedbackFilterV2(true, true))
    }

    webToTextFilterChange() {
        const activeQrCodeFilter = document.getElementById('filter-qr-codes-checkbox');
        const activeWebToTextFilter = document.getElementById('filter-web-to-text-checkbox');
        const activeNotWebToTextFilter = document.getElementById('filter-not-web-to-text-checkbox');

        if (activeWebToTextFilter.checked) {
            setWebToTextFilter()
            deleteQrCodeFilter()
            deleteNotWebToTextFilter()
            activeQrCodeFilter.checked = false;
            activeNotWebToTextFilter.checked = false;
        } else {
            deleteWebToTextFilter()
        }

        this.props.dispatch(ajaxFeedbackFilterV2(true, true))
    }

    notWebToTextFilterChange() {
        const activeQrCodeFilter = document.getElementById('filter-qr-codes-checkbox');
        const activeWebToTextFilter = document.getElementById('filter-web-to-text-checkbox');
        const activeNotWebToTextFilter = document.getElementById('filter-not-web-to-text-checkbox');

        if (activeNotWebToTextFilter.checked) {
            setNotWebToTextFilter()
            deleteQrCodeFilter()
            deleteWebToTextFilter()
            activeWebToTextFilter.checked = false;
            activeQrCodeFilter.checked = false;
        } else {
            deleteNotWebToTextFilter()
        }

        this.props.dispatch(ajaxFeedbackFilterV2(true, true))
    }

    employeeFilterChange() {
        const activeEmployeeFilter = document.getElementById('activate-employee-filter');
        const employeeFilterInputs = document.querySelectorAll('.employee-filter-input');
        const employeeFilter = document.getElementById('employee-filter');
        let filterByEmployee = [];

        if (activeEmployeeFilter.checked && employeeFilterInputs.length > 0 && employeeFilter.style.display !== 'none') {
            employeeFilterInputs.forEach((input) => {
                if (input.checked) {
                    filterByEmployee.push(parseInt(input.getAttribute('data-filter')));
                }
            });

            setEmployeeFilter(filterByEmployee.length ? filterByEmployee : [])
        } else {
            // reset it all
            employeeFilterInputs.forEach(input => {
                input.checked = false;
            });
            // filterByEmployee = null;
            // setEmployeeFilter(filterByEmployee);
            deleteEmployeeFilter();
        }

        this.props.dispatch(ajaxFeedbackFilterV2(true, true))
    }

    updateChecked(e) {
        let checked = $(e.target).is(":checked") ? 'all' : 'none';
        this.props.dispatch(updateCheckedFeedbacks(checked));
    }

    doPagination() {
        let e = event.target;
        let np = $(e).attr("data-direction");
        let current = this.props.state.current_page;
        switch (np) {
            case "next":
                current += 1;
                break;
            case "prev":
                current -= 1;
                break;
        }
        this.props.dispatch(setCurrentPage(current));

        if (this.props.state.isDashboard) {
            setTimeout(() => {
                this.props.dispatch(ajaxFeedbackStatusFilter(this.props.state, null, null, null, null, this.props.excludeStatistics));
            }, 300);
        } else {
            this.props.dispatch(ajaxFeedbackFilterV2(true, null))
        }
    }

    setOpenStatus() {
        this.props.dispatch(ajaxCheckedFeedbackStatus(window.feedbackStatus.Open.value, this.props.state))
    }

    setPendingStatus() {
        this.props.dispatch(ajaxCheckedFeedbackStatus(window.feedbackStatus.Pending.value, this.props.state))
    }

    setResolvedStatus() {
        let checked_feedbacks = this.props.state.checked_feedbacks;
        let initial_feedbacks = this.props.state.initial_feedbacks;

        if (checkPropertyValueByObjectIds(initial_feedbacks, checked_feedbacks, 'priority', 30)) {

            const modal_type = "bulkResolve";
            const modal_id = "statusModal";
            const modal_title = __("Warning:");
            const modal_body = __("You are changing the status of some Feedbacks that have not been responded to yet.");
            const button_1_class = "outline-secondary";
            const button_1_id = "cancel";
            const button_1_text = __("Cancel");
            const button_2_class = "primary";
            const button_2_id = "setResolvedAll";
            const button_2_text = __("Continue");

            this.props.dispatch(updateModalContent({
                modal_type: modal_type,
                modal_id: modal_id,
                modal_title: modal_title,
                modal_body: modal_body,
                button_1_class: button_1_class,
                button_1_id: button_1_id,
                button_1_text: button_1_text,
                button_2_class: button_2_class,
                button_2_id: button_2_id,
                button_2_text: button_2_text
            }));
            jQuery('.modal:not(.error)').modal();
        } else {
            this.props.dispatch(ajaxCheckedFeedbackStatus(window.feedbackStatus.Resolved.value, this.props.state))
        }
    }

    doPaginationCount() {
        let count = parseInt($(event.target).text());
        window.localStorage.setItem("feedback_page_count", count);
        this.props.dispatch(setPaginateCount(count));
        this.props.dispatch(setCurrentPage(1));
        if (this.props.state.isDashboard) {
            setTimeout(() => {
                this.props.dispatch(ajaxFeedbackStatusFilter(this.props.state, null, null, null, null, this.props.excludeStatistics));
            }, 300);
        } else {
            this.props.dispatch(ajaxFeedbackFilterV2(true, null))
        }
    }


    doSorting() {
        let data = $(event.target).data('value');

        if (data === undefined) {
            data = $(event.target).children().first().data('value')
        }

        this.props.dispatch(setSorting(data));

        if (this.props.state.isDashboard) {
            setTimeout(() => {
                this.props.dispatch(ajaxFeedbackStatusFilter(this.props.state, null, null, null, null, this.props.excludeStatistics));
            }, 300);
        } else {
            this.props.dispatch(ajaxFeedbackFilterV2(true, null))
        }
    }

    getSortingName(sortId) {
        const sortNames =
            {
                'sort-created_at-desc': __('Date Newest'),
                'sort-created_at-asc': __('Date Oldest'),
                'sort-priority-desc': __('High priority'),
                'sort-priority-asc': __('Low priority'),
                'sort-smiley_score-desc': __('High smiley face'),
                'sort-smiley_score-asc': __('Low smiley face'),
                'sort-sentiment_score-desc': __('High sentiment score'),
                'sort-sentiment_score-asc': __('Low sentiment score')
            };

        return sortNames[sortId];
    }

    renderStars = (r) => {
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            stars.push(
                <span key={i}>
          {i <= r ? <i className="fas fa-star text-warning"></i> : <i className="far fa-star text-warning"></i>}
        </span>
            );
        }
        return stars;
    }


    render() {
        return (
            <div className="filter-bar-wrapper">
                {this.props.state.title !== "More" && !this.props.state.isDashboard && this.props.position !== "bottom" &&
                    <RatingFilter key="ratingFilter">
                        {this.props.state.businessHasAutoPilot &&
                            // Filter by Ratings
                            <div className="d-flex filters-wrapper filterby">
                                <div className="d-flex align-items-center pl-1">
                                    <label className="cursor-pointer mt-1 ml-2">
                                        <input
                                            id="activate-rating-filter"
                                            type="checkbox"
                                            name="activate-rating-filter"
                                            className="feedback-card-v2-checkbox mr-2"
                                            style={{width: '16px', height: '16px'}}
                                            onChange={this.toggleRatingsFilter.bind(this)}
                                            defaultChecked={getRatingsFilter()}
                                        />
                                    </label>
                                    <label htmlFor="activate-rating-filter" className="feedback-card-v2-checkbox">{ __('Filter by Ratings') }</label>
                                </div>
                                <div className="row" id="rating-filter"
                                     style={{display: getRatingsFilter() ? 'block' : 'none'}}>
                                    <div className="col-12 mb-2">
                                        <p className="mb-0">
                                            <img src="/img/onethrufive-sm.png" className="close-ro-logo mr-2" alt=""/>
                                        </p>
                                    </div>
                                    {Array.from({length: 5}, (_, index) => (
                                        <div className="col-12" key={index}>
                                            <label
                                                htmlFor={`star-filter-${5 - index}-stars`}
                                                className="d-flex align-items-center mb-0 cursor-pointer star-filter"
                                                data-filter={5 - index}
                                                style={{maxWidth: 'fit-content'}}
                                            >
                                                <input
                                                    type="checkbox"
                                                    id={`star-filter-${5 - index}-stars`}
                                                    className="cursor-pointer mr-2 star-filter-input"
                                                    data-filter={5 - index}
                                                    defaultChecked={(getRatingsFilter() && getRatingsFilter().includes(5 - index))}
                                                    onChange={this.handleRatingsFilterChange}
                                                />
                                                <p className="mb-0 pl-0 pr-0">
                                                    {this.renderStars(5 - index)}
                                                </p>
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        }

                        {this.props.state.user_departments.length > 0 &&
                            // Filter by Department
                            <div className="d-flex filters-wrapper filterby sm:ml-5 filter-bar-wrapper">
                                <div className="d-flex align-items-center pl-1">
                                    <label className="cursor-pointer mt-1 ml-2">
                                        <input
                                            id="activate-department-filter"
                                            name="activate-department-filter"
                                            type="checkbox"
                                            className="feedback-card-v2-checkbox mr-2"
                                            style={{width: '16px', height: '16px'}}
                                            onChange={this.toggleDepartmentFilter.bind(this)}
                                            defaultChecked={getDepartmentFilter()}
                                        />
                                    </label>
                                    <label htmlFor="activate-department-filter" className="feedback-card-v2-checkbox"
                                           style={{marginBottom: '0.5rem'}}>{ __('Filter by Department') }</label>
                                </div>
                                <div className="" id="department-filter"
                                     style={{display: getDepartmentFilter() ? 'block' : 'none'}}>
                                    <div className="row department-group"
                                         data-full={this.state.showDeptList}
                                         style={{display: getDepartmentFilter() ? 'flex' : 'none'}}>

                                        {splitArrayInByNumbers(this.props.state.user_departments, 4).map((department_group, i) => (
                                            <div key={i} style={{width: '250px'}} className="mt-2">
                                                {department_group.map((department) => (
                                                    <div className="col-12" key={department.id}>
                                                        <label
                                                            className="d-flex align-items-center mb-0"
                                                            data-filter={department.id}
                                                            style={{maxWidth: 'fit-content'}}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                id={`dept-filter-${department.id}`}
                                                                className="mr-2 department-filter-input"
                                                                data-filter={department.id}
                                                                defaultChecked={getDepartmentFilter() && getDepartmentFilter().includes(department.id)}
                                                                onChange={this.handleDepartmentFilterChange}
                                                            />
                                                            <p className="mb-0 pl-0 pr-0">{department.name}</p>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                    {/* button */}
                                    {this.props.state.user_departments.length > 5 &&
                                        <button className="filter-expand-btn" onClick={this.handleDeptListToggle}>
                                            {this.state.showDeptList ? 'collapse' : 'show all'}
                                        </button>
                                    }
                                </div>
                            </div>
                        }

                        {this.props.state.businessHasWebWidget &&
                            // Filter by Origin
                            <div className="d-flex filters-wrapper filterby sm:ml-5 filter-bar-wrapper">
                                <div className="d-flex align-items-center pl-1">
                                    <label className="cursor-pointer mt-1 ml-2">
                                        <input
                                            id="activate-origin-filter"
                                            name="activate-origin-filter"
                                            type="checkbox"
                                            className="feedback-card-v2-checkbox mr-2"
                                            style={{width: '16px', height: '16px'}}
                                            onChange={this.toggleOriginFilter.bind(this)}
                                            defaultChecked={getOriginFilter()}
                                        />
                                    </label>
                                    <label htmlFor="activate-origin-filter" className="feedback-card-v2-checkbox"
                                           style={{marginBottom: '0.5rem'}}>{ __('Filter by Origin') }</label>
                                </div>
                                <div className="" id="origin-filter"
                                     style={{display: getOriginFilter() ? 'block' : 'none'}}>
                                    <div className="row origin-group">
                                        <div className="mt-2">
                                            <div className="col-12 d-flex">
                                                <input
                                                    type="checkbox"
                                                    name="filter-web-to-text-checkbox"
                                                    id="filter-web-to-text-checkbox"
                                                    className="feedback-card-v2-checkbox mx-2"
                                                    style={{width: '16px', height: '16px'}}
                                                    onChange={this.webToTextFilterChange.bind(this)}
                                                    defaultChecked={getWebToTextFilter()}
                                                />
                                                <label htmlFor="filter-web-to-text-checkbox"
                                                       className="feedback-card-v2-checkbox"
                                                       style={{marginBottom: '0.5rem'}}>
                                                    { __('Show Only Web-to-Text') }
                                                </label>
                                            </div>
                                        </div>
                                        <div className="mt-2">
                                            <div className="col-12 d-flex">
                                                <input
                                                    type="checkbox"
                                                    name="filter-not-web-to-text-checkbox"
                                                    id="filter-not-web-to-text-checkbox"
                                                    className="feedback-card-v2-checkbox mx-2"
                                                    style={{width: '16px', height: '16px'}}
                                                    onChange={this.notWebToTextFilterChange.bind(this)}
                                                    defaultChecked={getNotWebToTextFilter()}
                                                />
                                                <label htmlFor="filter-not-web-to-text-checkbox"
                                                       className="feedback-card-v2-checkbox"
                                                       style={{marginBottom: '0.5rem'}}>
                                                    { __('Don\'t Show Any Web-to-Text') }
                                                </label>
                                            </div>
                                        </div>
                                        <div className="mt-2">
                                            <div className="col-12 d-flex">
                                                <input
                                                    type="checkbox"
                                                    name="filter-qr-codes-checkbox"
                                                    id="filter-qr-codes-checkbox"
                                                    className="feedback-card-v2-checkbox mx-2"
                                                    style={{width: '16px', height: '16px'}}
                                                    onChange={this.qrCodeFilterChange.bind(this)}
                                                    defaultChecked={getQrCodeFilter()}
                                                />
                                                <label htmlFor="filter-qr-codes-checkbox"
                                                       className="feedback-card-v2-checkbox"
                                                       style={{marginBottom: '0.5rem'}}>
                                                    { __('Show Only Feedbacks Generated by QR Codes') }
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    {/* button */}
                                    {this.props.state.user_departments.length > 5 &&
                                        <button className="filter-expand-btn" onClick={this.handleDeptListToggle}>
                                            {this.state.showDeptList ? __('collapse') : __('show all')}
                                        </button>
                                    }
                                </div>
                            </div>
                        }

                        {this.props.state.feedback_tags.length > 0 &&
                            // Filter by Tag
                            <div className="d-flex filters-wrapper filterby sm:ml-5 filter-bar-wrapper">
                                <div className="d-flex align-items-center pl-1">
                                    <label className="cursor-pointer mt-1 ml-2">
                                        <input
                                            id="activate-tag-filter"
                                            name="activate-tag-filter"
                                            type="checkbox"
                                            className="feedback-card-v2-checkbox mr-2"
                                            style={{width: '16px', height: '16px'}}
                                            onChange={this.toggleTagFilter.bind(this)}
                                            defaultChecked={getTagFilter()}
                                        />
                                    </label>
                                    <label htmlFor="activate-tag-filter" className="feedback-card-v2-checkbox"
                                           style={{marginBottom: '0.5rem'}}>{ __('Filter by Tag') }</label>
                                </div>
                                <div className="" id="tag-filter"
                                     style={{display: getTagFilter() ? 'block' : 'none'}}>
                                    <div className="row department-group"
                                         data-full={this.state.showTagsList}
                                         style={{display: getTagFilter() ? 'flex' : 'none'}}>

                                        {splitArrayInByNumbers(this.props.state.feedback_tags, 4).map((tag_group, i) => (
                                            <div key={i} style={{width: '250px'}} className="mt-2">
                                                {tag_group.map((tag) => (
                                                    <div className="col-12" key={tag.id}>
                                                        <label
                                                            className="d-flex align-items-center mb-0"
                                                            data-filter={tag.id}
                                                            style={{maxWidth: 'fit-content'}}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                id={`dept-filter-${tag.id}`}
                                                                className="mr-2 tag-filter-input"
                                                                data-filter={tag.id}
                                                                defaultChecked={getTagFilter() && getTagFilter().includes(tag.id)}
                                                                onChange={this.handleTagFilterChange}
                                                            />
                                                            <p className="mb-0 pl-0 pr-0">{tag.label}</p>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                    {/* button */}
                                    {this.props.state.feedback_tags.length > 5 &&
                                        <button className="filter-expand-btn" onClick={this.handleTagsListToggle}>
                                            {this.state.showTagsList ? __('collapse') : __('show all')}
                                        </button>
                                    }
                                </div>
                            </div>
                        }

                        {!this.props.state.businessHasWebWidget &&
                            <div className="d-flex filters-wrapper filterby extra-filter sm:ml-5">
                                <div className="d-flex align-items-start pl-1">
                                    <label className="cursor-pointer mt-1 ml-2">
                                        <input
                                            type="checkbox"
                                            name="filter-qr-codes-checkbox"
                                            id="filter-qr-codes-checkbox"
                                            className="feedback-card-v2-checkbox mr-2"
                                            style={{width: '16px', height: '16px'}}
                                            onChange={this.qrCodeFilterChange.bind(this)}
                                            checked={getQrCodeFilter()}
                                        />
                                    </label>
                                    <label htmlFor="filter-qr-codes-checkbox" className="feedback-card-v2-checkbox"
                                           style={{marginBottom: '0.5rem'}}>
                                        { __('Show Only Feedbacks Generated by QR Codes') }
                                    </label>
                                </div>
                            </div>
                        }

                        {/* Filter by Employee */}
                        {this.props.state.businessEmployees.length > 0 &&
                            <div className="d-flex filters-wrapper sm:ml-5 filter-bar-wrapper filterby">
                            <div className="d-flex align-items-center pl-1">
                                <label className="cursor-pointer mt-1 ml-2">
                                    <input
                                        id="activate-employee-filter"
                                        name="activate-employee-filter"
                                        type="checkbox"
                                        className="feedback-card-v2-checkbox mr-2"
                                        style={{width: '16px', height: '16px'}}
                                        onChange={this.toggleEmployeeFilter.bind(this)}
                                        defaultChecked={getEmployeeFilter()}
                                    />
                                </label>
                                <label htmlFor="activate-employee-filter" className="feedback-card-v2-checkbox">{ __('Filter by Assigned') }</label>
                            </div>
                            <div id="employee-filter" style={{display: getEmployeeFilter() ? 'block' : 'none'}}>
                                <div className="row department-group" data-full={this.state.showEmployeeList}>
                                    {[...this.props.state.businessEmployees]
                                        .sort((a, b) => {
                                            const currentUserLowerCase = (this.props.state.currentUser.firstname + " " + this.props.state.currentUser.lastname).toLowerCase();
                                            if (a.name.toLowerCase() === currentUserLowerCase) return -1;
                                            if (b.name.toLowerCase() === currentUserLowerCase) return 1;
                                            return a.name.localeCompare(b.name);
                                        })
                                        .map((employee, i) => (
                                        <div key={i} style={{width: '250px'}} className="mt-2">
                                             <div className="col-12" key={employee.id}>
                                                 <label
                                                     className="d-flex align-items-center mb-0"
                                                     data-filter={employee.id}
                                                     style={{maxWidth: 'fit-content'}}
                                                 >
                                                     <input
                                                         type="checkbox"
                                                         id={`dept-filter-${employee.id}`}
                                                         className="mr-2 employee-filter-input"
                                                         data-filter={employee.id}
                                                          defaultChecked={getEmployeeFilter() && getEmployeeFilter().includes(employee.id)}
                                                          onChange={this.handleEmployeeFilterChange}
                                                     />
                                                     <p className="mb-0 pl-0 pr-0">{employee.name}</p>
                                                 </label>
                                             </div>
                                        </div>
                                    ))}
                                </div>
                                {/* button */}
                                {/*{this.props.state.user_departments.length > 5 &&*/}
                                {/*    <button className="filter-expand-btn" onClick={this.handleDeptListToggle}>*/}
                                {/*        {this.state.showDeptList ? 'collapse' : 'show all'}*/}
                                {/*    </button>*/}
                                {/*}*/}
                            </div>
                        </div>
                        }


                    </RatingFilter>
                }

                {this.props.position !== "bottom"
                    ? <Bar key="bar">
                        <div className={'d-flex justify-content-between w-100 search-bar-wrapper pl-1'}>
                            {this.props.state.initial_feedbacks.length !== 0 && this.props.state.title !== 'More' && !this.props.state.isDashboard ?
                                <div className={'d-flex'}>
                                    <div className="d-flex filters-wrapper extra-filter flex-column">
                                        <div className="d-flex align-items-center">
                                            <label className="cursor-pointer mt-1 ml-2">
                                                <input
                                                    type="checkbox"
                                                    name="bulk-action-checkbox"
                                                    id="bulk-action-checkbox"
                                                    className="feedback-card-v2-checkbox mr-2"
                                                    style={{width: '16px', height: '16px'}}
                                                    onChange={this.updateChecked.bind(this)}
                                                    checked={this.props.state.checked_feedbacks.length === this.props.state.initial_feedbacks.length
                                                    }
                                                />
                                            </label>
                                            <label htmlFor="bulk-action-checkbox" className="feedback-card-v2-checkbox"
                                                   style={{
                                                       display: this.props.state.checked_feedbacks.length === 0 ? 'inline-block' : 'none',
                                                       marginBottom: '0.5rem'
                                                   }}>{ __('Display Bulk Actions') }</label>
                                        </div>
                                        <div className="align-items-center ml-3" style={{
                                            display: this.props.state.checked_feedbacks.length === 0 ? 'none' : 'flex',
                                            marginBottom: '0.5rem'
                                        }}>
                                            <button className="btn-sm btn btn-primary mr-2"
                                                    onClick={this.setOpenStatus.bind(this)}>{ __('Open') }
                                            </button>
                                            <button className="btn-sm btn btn-warning mr-2"
                                                    onClick={this.setPendingStatus.bind(this)}>{ __('Pending') }
                                            </button>
                                            <button className="btn-sm btn btn-success mr-2"
                                                    onClick={this.setResolvedStatus.bind(this)}>{ __('Resolved') }
                                            </button>
                                        </div>
                                    </div>
                                </div> : <div/>}
                            <div className={'d-flex filters-wrapper'}>

                                <FormDropdown
                                    classes="d-flex align-items-center"
                                    menuClasses="thin-menu"
                                    buttonClasses="p-1 bg-white no-arrow"
                                    itemOnClickFunction={this.doSorting.bind(this)}
                                    title={<>
                                        <span
                                            className={'mr-1'}>{ __('Sort by') }: {this.getSortingName((this.props.state.sorting === null || this.props.state.sorting === 'null') ? 'sort-created_at-desc' : this.props.state.sorting)}</span>
                                        <img src="/img/filter.svg"></img>
                                    </>}
                                    items={[
                                        {
                                            text: <><i className="text-gray fas fa-chevron-up mr-2"
                                                       data-value="sort-created_at-desc"></i><span className="mr-4"
                                                                                                   data-value="sort-created_at-desc">{this.getSortingName('sort-created_at-desc')}</span></>
                                        },
                                        {
                                            text: <><i className="text-gray fas fa-chevron-down mr-2"
                                                       data-value="sort-created_at-asc"></i><span className="mr-4"
                                                                                                  data-value="sort-created_at-asc">{this.getSortingName('sort-created_at-asc')}</span></>
                                        },
                                        {
                                            text: <><i className="text-gray fas fa-chevron-up mr-2"
                                                       data-value="sort-priority-desc"></i><span className="mr-auto"
                                                                                                 data-value="sort-priority-desc">{this.getSortingName('sort-priority-desc')}</span></>
                                        },
                                        {
                                            text: <><i className="text-gray fas fa-chevron-down mr-2"
                                                       data-value="sort-priority-asc"></i><span className="mr-auto"
                                                                                                data-value="sort-priority-asc">{this.getSortingName('sort-priority-asc')}</span></>
                                        },
                                        {
                                            text: <><i className="text-gray fas fa-chevron-up mr-2"
                                                       data-value="sort-smiley_score-desc"></i><span className="mr-auto"
                                                                                                     data-value="sort-smiley_score-desc">{this.getSortingName('sort-smiley_score-desc')}</span></>
                                        },
                                        {
                                            text: <><i className="text-gray fas fa-chevron-down mr-2"
                                                       data-value="sort-smiley_score-asc"></i><span className="mr-auto"
                                                                                                    data-value="sort-smiley_score-asc">{this.getSortingName('sort-smiley_score-asc')}</span></>
                                        },
                                        {
                                            text: <><i className="text-gray fas fa-chevron-up mr-2"
                                                       data-value="sort-sentiment_score-desc"></i><span
                                                className="mr-auto"
                                                data-value="sort-sentiment_score-desc">{this.getSortingName('sort-sentiment_score-desc')}</span></>
                                        },
                                        {
                                            text: <><i className="text-gray fas fa-chevron-down mr-2"
                                                       data-value="sort-sentiment_score-asc"></i><span
                                                className="mr-auto"
                                                data-value="sort-sentiment_score-asc">{this.getSortingName('sort-sentiment_score-asc')}</span></>
                                        },
                                    ]}
                                    tooltip={this.getSortingName((this.props.state.sorting === null || this.props.state.sorting === 'null') ? 'sort-created_at-desc' : this.props.state.sorting)}
                                />
                                <FormDropdown
                                    classes="d-flex align-items-center"
                                    menuClasses="thin-menu roboto"
                                    buttonClasses="p-1 bg-white roboto"
                                    itemOnClickFunction={this.doPaginationCount.bind(this)}
                                    title={this.props.state.paginate_count}
                                    items={[
                                        {text: "10"},
                                        {text: "25"},
                                        {text: "50"},
                                        {text: "100"}
                                    ]}
                                    tooltip={__('Items per Page')}
                                />
                                <div className={'d-flex'}>
                                    <Pagination
                                        onNextClick={this.doPagination.bind(this)}
                                        onPrevClick={this.doPagination.bind(this)}
                                        total={this.props.state.feedback_count}
                                        increment={this.props.state.paginate_count}
                                    />
                                </div>
                            </div>
                        </div>
                    </Bar>

                    // show this at the bottom of the form
                    : <Bar key="bar">
                        <div className='d-flex justify-content-end w-100'>
                            <div className={'d-flex'}>
                                <Pagination
                                    onNextClick={this.doPagination.bind(this)}
                                    onPrevClick={this.doPagination.bind(this)}
                                    total={this.props.state.feedback_count}
                                    increment={this.props.state.paginate_count}
                                />
                            </div>
                        </div>
                    </Bar>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {state: state}
}

export default connect(mapStateToProps)(FilterBar);
